import { ImageProps } from 'next/image';
import Media from './media';

export default class Image {
  image?: Media;
  mobileImage?: Media;
  scrollSpeed?: number;
  strict?: boolean;
  fit?: ImageProps['objectFit'];
  position?: ImageProps['objectPosition'];
  priority?: boolean;

  constructor(props: any) {
    const { image, mobileImage, scrollSpeed, strict, fit, position, priority } =
      props;
    this.image = image ? new Media(image) : undefined;
    this.mobileImage = mobileImage ? new Media(mobileImage) : undefined;
    this.scrollSpeed = scrollSpeed || 0;
    this.strict = strict || false;
    this.fit = fit || 'cover';
    this.priority = priority || false;
    this.position = position || 'center';
  }
}
